import { history } from '../reducers';
import * as eventsUser from '../types/user';
import { UserAction, UserType } from '../types/user';

export const replaceUser = (user: UserType) => {
  return {
    type: UserAction.REPLACE_USER,
    user: user
  };
};

export const logoutUser = () => {
  history.push('/');
  return {
    type: UserAction.REPLACE_USER,
    user: { isLogged: false }
  };
};
